import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Placeholder from 'react-bootstrap/Placeholder';
import { GetAccessToken } from "../index";
import { useMsal } from "@azure/msal-react";
import { DisplaySavedMessage } from './DisplaySavedMessage';
import Toast from 'react-bootstrap/Toast';
import Checkbox from "@mui/material/Checkbox";
import "./AddNilReturn.css";
import { msalConfig } from '../authConfig';
import { useAppConfig } from '../config/AppConfigContext';
import { useEffect } from 'react';
import { useNavigate} from 'react-router-dom'
export function AddNilReturn() {
    const initialNilState= {
        "ReinzId": "",
        "ReturnPeriod": (new Date((new Date()).setMonth((new Date()).getMonth()))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth()))).getFullYear(),
        "IsNilReturn": false,
        "Residential": true,
        "Rural": false
    }
    const { instance } = useMsal();
    const [data, setData] = useState(false);
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [nil, setnil] = useState(initialNilState);
    const [error, setError] = useState('');
    const [errorMessage, seterrorMessage] = useState('');
    const [message, setMessage] = useState(null);
    const [isOrgVisible, setOrgIsVisible] = useState(true);
    const [searchOrgResults, setOrgSearchResults] = useState([]);
    const [searchOrgsResults, setOrgsSearchResults] = useState([]);
    const [showToast, setShowToast] = useState(false);
    var orgEntered = "";
    const config = useAppConfig();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [validationError, setValidationError] = useState(null);

    //Get agency name
    useEffect(() => {
        const fetchAgency = async () => {
            const url = "api/ReturnList/GetAgencyName";
            const tokenRequest = {
                scopes: config.apiScopes,
                account: instance.getActiveAccount()
            };
            const accessToken = await GetAccessToken(tokenRequest);

            try {
                await fetch(url,
                    {
                        method: "GET",
                        headers: new Headers(
                            {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${accessToken}`
                            }),
                    })
                    .then((response) => {
                        console.log(response, 'response');
                        if (response.status !== 200 && response.status !== 201) {
                            console.log("not ok" + response.status);
                        }
                        else {
                            return response.json()
                        }
                    })
                    .then(data => {
                        console.log(data)
                        if (data !== null && data !== undefined) {
                            //newresidential.OfficeReinzId = data;
                            //setresidential(newresidential);
                            setnil(prev => ({
                                ...prev,
                                ReinzId: data
                            }));
                        }
                    })
                    //setIsLoading(false)
                    .catch(error => {
                        console.error('Error:', error);
                    });
            }
            catch (error) {
                if (error.response) {
                    console.log(error);
                }
            }
        }
        fetchAgency();
    }, [])

    function handle(e) {
        const newnil = { ...nil }
        newnil[e.target.id] = e.target.value
        setnil(newnil)
        console.log(newnil)
    }
    function handleOfficesSearch(e) {
        const { id } = e.target;
        orgEntered = e.target.value;
        setnil((prev) => ({
            ...prev,
            ReinzId: orgEntered
        }));
        setOrgIsVisible(true);
        /*setSelectedOrg(orgEntered);*/
        if (orgEntered.length >= 4) {
            handleOffices();
        }
    }
    const handleOffices = async () => {
        const url = "api/organisation/GetOrganisation";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);
        try {
            fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }),
                body: JSON.stringify(orgEntered)
            })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                        setOrgSearchResults(data);
                        //setOrgIsVisible(true);
                    }
                })
                .catch(error => {
                    console.error('Error fetching organisations', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    const handleSelectOrg = (org) => {
        if (org && !searchOrgsResults.includes(org.trim())) {
            setOrgsSearchResults((searchOrgsResults) => {
                const updatedOrgsList = [...searchOrgsResults, org.trim()]
                // Update state
                setnil((prevData) => ({ ...prevData, ReinzId: org }));
                /*setOrgSearchResults(['']);*/
                return updatedOrgsList;// Return the updated list for the state
            });
        }
        setOrgIsVisible(false);
        /*setOrgsIsVisible(true);*/
    };
 
    const checkboxHandle = (event) => {
        const { name, checked } = event.target; // Get the name and checked value from the event

        // Update the state dynamically based on the checkbox's name and checked value
        setnil((prevState) => ({
            ...prevState,
            [name]: checked, // Update the specific checkbox state
            IsNilReturn: true
        }));
    };
    const [showLastMonths] = useState([
        {
            key: 1,
            value: (new Date((new Date()).setMonth((new Date()).getMonth()))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth()))).getFullYear()
        },
        {
            key: 2,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 1))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 1))).getFullYear()
        },
        {
            key: 3,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 2))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 2))).getFullYear()
        },
        {
            key: 4,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 3))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 3))).getFullYear()
        }
    ]);

    
    const Submit = async (e) => {
        e.preventDefault();
        /*alert("Hello1");*/
        const form = document.getElementById('AddNilReturnForm');
        if (!form.checkValidity()) {
            e.stopPropagation();
            setValidated(true);
            seterrorMessage(true);
            setValidationError('Please fill in all required fields.');
            setError('Please fill in all required fields.');
            return; // Prevent submission if invalid
        }
        setValidated(true);
        setError(null);
        setValidationError(null);
        seterrorMessage(false);
        
        const url = "/api/NilReturn/CreateNilReturn";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        try {
            setLoading(true);
            const accessToken = await GetAccessToken(tokenRequest);
            //fetch
            const response = await fetch(url,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(nil),

                });
            if (!response.ok) {
                console.log("not ok" + response.status);
                throw new Error('Network response was not ok');
            }
            else {
                const data = await response.json();
                setShowToast(true);
                setLoading(false);
                /*setMessage(true);*/
                //setMessage('Sale created successfully');
                //seterrorMessage(false);
                //setTimeout(() => {
                //    setMessage(false);
                //}, 5000);
            }
        }
        catch (error) {
            console.log(error);
            setLoading(false);
            setMessage('Error saving data. Please try again.');
            seterrorMessage(true);
            setTimeout(() => {
                setMessage(false);
            }, 5000);
        }
    }
    
    //const theme = createTheme({
    //    // Customize your theme if necessary
    //});

    return (
        <>            
                <div className="container" id="AddNilReturn">
                <h1>File a Nil Return</h1>
                    <form id="AddNilReturnForm" noValidate validated={validated}>
                   
                    <Toast show={showToast} style={{
                        position: 'fixed',
                        top: '25%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 9999,
                        minWidth: '300px',
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa', // Optional: Light background
                        border: '1px solid #28a745'

                    }} onClose={() => setShowToast(false)}>

                        <Toast.Header style={{
                            color: 'green',
                            fontWeight: 'bold',
                            fontSize: '1.2rem'
                        }}>
                            <strong className="me-auto">Sale created successfully!</strong>
                        </Toast.Header>
                        <Toast.Body>
                            Do you want to create a new return?
                            <div className="mt-3 d-flex justify-content-around">
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    type="button"
                                    onClick={()=>navigate('/GetReturnsListNil')}>
                                    Close
                                </Button>
                                <Button
                                    variant="success"
                                    size="sm"
                                    type="button"
                                    onClick={() => {
                                        setShowToast(false);
                                        setnil(initialNilState);
                                        //setnil(prev => ({
                                        //    ...initialNilState,
                                        //   OfficeReinzId: prev.OfficeReinzId
                                        //}));
                                        console.log('Reset to:', initialNilState);
                                    }}>
                                    Confirm
                                </Button>
                            </div>
                        </Toast.Body>
                    </Toast>
                        <div className="form-group">
                            <label htmlFor="ReturnPeriodInput" className="labelClass">Return Period <span style={{ color: 'red' }}>*</span></label>
                            <div id="SelectStyle">
                                <select name="ReturnPeriod" className="form-control">
                                    value={nil.ReturnPeriod}
                                    onChange={(e) => handle(e)}
                                    {showLastMonths.map((info) => (
                                        <option className="form-control" key={info.key} value={info.value}>{info.value}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                        <label htmlFor="ReinzId" className="labelClass">Office <span style={{ color: 'red' }}>*</span></label>
                            <div className="input-group">
                            <span className="input-group-text" id="dollar-sign">
                            <i className="bi bi-search iconStyles"></i>
                            </span>
                            <input type="text" className="form-control" id="ReinzId" value={nil.ReinzId||''} onChange={(e) => handleOfficesSearch(e)}
                            placeholder="Start typing to search through Agencies" required /><br/>
                        </div>
                        {(nil.ReinzId === '') &&
                            <div style={{ color: 'red' }}>{error}</div>
                        }
                        {isOrgVisible &&
                            <ul id="ConjointOfficeReinzId" className="List">
                                {searchOrgResults.map((org, index) => (
                                    <li key={index} onClick={() => handleSelectOrg(org)}>
                                        {org}
                                    </li>
                                ))}
                            </ul>
                        }
                        </div>
                        <div className="form-group">
                            <div className="col-sm-1" style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox id="Residential" name="Residential"
                                checked={nil.Residential}
                                onChange={checkboxHandle}
                                sx={{
                                    color: '#563abe',
                                    '&.Mui-checked': {
                                        color: '#563abe',
                                    },
                                }} required={!(nil.Residential || nil.Rural)}
                            />
                            <label htmlFor="Residential" className="labelClass">{!(nil.Residential || nil.Rural)&& <span style={{ color: 'red' }}>*</span>}Residential</label>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-1" style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox id="Rural" name="Rural"
                                checked={nil.Rural}
                                onChange={checkboxHandle}
                                sx={{
                                    color: '#563abe',
                                    '&.Mui-checked': {
                                        color: '#563abe',
                                    },
                                }} required={!(nil.Residential || nil.Rural) }
                                />
                            <label htmlFor="Rural" className="labelClass">{!(nil.Residential || nil.Rural) && <span style={{ color: 'red' }}>*</span>}Rural</label>
                            </div>
                        </div>
                        <div id="FileReturnButton">
                            <input type="submit" value="File Return" onClick={Submit} className="btn FileReturnButtonClass" />
                        </div>
                </form>
                {/*{data === true && <DisplaySavedMessage />}*/}
                {message && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{message}</div>}
                {validationError && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{validationError}</div>}
                {/* Loading overlay */}
                {loading && (
                    <div className="overlay">
                        <div className="spinner"></div>
                        <p style={{ color: 'black', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>Processing... Please wait</p>
                    </div>
                )}
                </div>
            
        </>
    );
}
